import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import FooterActions from "./AssignBuildingFooter";
import HeaderBreadCrumb from "./AssignBuildingHeader";
import { Button } from "primereact/button"; // Import Button
import {
  retrieveBuildingInfoById,
  setContractInfo,
  unAssignSystemServices,
  validateUnassignSystemContract,
  validateSystemService,
  setSelectedContract,
  setIsSystemsPopupOpened,
} from "src/redux/slices/assignBuildingSlice";
import "./AssignBuilding.scss";
import { useSelector } from "react-redux";
import { Trans, useTranslation } from "react-i18next";
import {
  getFieldFieldValue,
  getTextValueById,
  isArabic,
} from "src/utils/helpers";
import { IContractSystemServicesInfo } from "src/redux/interfaces/IAssignBuilding";
import { toast } from "react-toastify";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import CustomInputNumber from "../InputNumber/InputNumber";
import AssignBuildingTitle from "./AssignBuildingTitle";
import { IBmcBuildingInfo } from "src/redux/interfaces/IAssignBuilding";
import _ from "lodash";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { useNavigate } from "react-router";
import { RoutePaths } from "src/resources/enum";

const Systems = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { t } = useTranslation(["common", "assignBuilding"]);

  const [isNextButtonClicked, setIsNextButtonClicked] =
    useState<boolean>(false);
  const systems = useSelector((state: any) => state.lookup.systems);
  var contractDetails = useSelector(
    (state: any) => state.assignBuilding.contractInfo
  );

  const buildingInfo = useSelector(
    (state: any) => state.assignBuilding.buildingInfo
  );
  const bmcBuildingInfo = useSelector(
    (state: any) => state.assignBuilding.bmcBuildingInfo
  ) as IBmcBuildingInfo;

  const isSystemsPopupOpened = useSelector(
    (state: any) => state.assignBuilding.isSystemsPopupOpened
  );

  //useref to keep old ids
  const oldIds = useRef(
    contractDetails.contractSystemServicesInfo.map(
      (system: any) => system.systemServiceId
    )
  );

  var [selectedSystems, setSelectedSystems] = useState<any>([]);

  const addSystem = async (system: any): Promise<void> => {
    //var selected = {id :system.id , name : system.name};
    setIsNextButtonClicked(false);

    if (
      selectedSystems.find(
        (se: { systemServiceId: any }) =>
          se.systemServiceId == system.systemServiceId
      )
    ) {
      toast.error(t("systemSelectedBeforeValidation"));
      return;
    }

    const propertyId = isSystemsPopupOpened
      ? bmcBuildingInfo?.buildingInfo?.propertyId
      : buildingInfo.propertyId;
    const contractId = contractDetails.contractId;
    const systemServiceId = system.systemServiceId;
    const response = await dispatch(
      validateSystemService(propertyId, contractId, systemServiceId) as any
    );
    if (!response.operationSucceeded) {
      toast.error(
        t(
          isArabic() ? response.errorDescriptionAr : response.errorDescriptionEn
        )
      );
      return;
    }

    var newSystem: IContractSystemServicesInfo = {
      bmcContractServicesId: "",
      make: null,
      model: null,
      quantity: null,
      systemService: "",
      systemServiceId: system.SystemServiceId,
      isMakeNull: false,
      isModelNull: false,
      isQuantityNull: false,
    };
    newSystem.systemServiceId = system.systemServiceId;
    setSelectedSystems([...selectedSystems, newSystem]);
  };

  useEffect(() => {
    setSelectedSystems(contractDetails.contractSystemServicesInfo);
  }, [dispatch]);

  const removeSystem = (system: any): void => {
    if (
      isSystemsPopupOpened &&
      oldIds.current.includes(system.systemServiceId)
    ) {
      // dispatch(
      //   validateUnassignSystemContract(
      //     bmcBuildingInfo.buildingInfo.propertyId,
      //     [system.systemServiceId]
      //   ) as any
      // ).then((response: any) => {
      // if (response.data.OperationResponse.OperationSucceeded !== 0) {
      //   if (response.data.unassignedContractsConfirmation.length === 0) {

      //   } else {
      // show confirmation message with contracts names
      confirm(system.systemServiceId);
      //   }
      // }
      // });
    } else {
      setSelectedSystems(
        selectedSystems.filter(
          (se: { systemServiceId: any }) =>
            se.systemServiceId !== system.systemServiceId
        )
      );
    }
  };
  const unassignSystemService = (systemServiceId: any): void => {
    dispatch(
      unAssignSystemServices(bmcBuildingInfo.buildingInfo.propertyId, [
        systemServiceId,
      ]) as any
    ).then((response: any) => {
      if (
        response.data.OperationResponse.OperationSucceeded &&
        response.data.ExceededContracts.length === 0
      ) {
        setSelectedSystems(
          selectedSystems.filter(
            (se: { systemServiceId: any }) =>
              se.systemServiceId !== systemServiceId
          )
        );
        toast.success(t("assetUnassignedSuccessfully"));

        if (bmcBuildingInfo.selectedContract) {
          const newSystems =
            bmcBuildingInfo.selectedContract.contractSystemServicesInfo.filter(
              (se: { systemServiceId: any }) =>
                se.systemServiceId !== systemServiceId
            );
          if (newSystems.length === 0) {
            // last service removed
            dispatch(setIsSystemsPopupOpened(false));
            dispatch(
              retrieveBuildingInfoById(
                bmcBuildingInfo.buildingInfo.propertyNumber,
                contractDetails.amcContractNumber
              ) as any
            );
          } else {
            dispatch(
              setSelectedContract({
                ...bmcBuildingInfo.selectedContract,
                contractSystemServicesInfo: newSystems,
              })
            );
          }
        }
      } else if (response.data.ExceededContractsResponse?.OperationSucceeded) {
        toast.error(
          isArabic()
            ? response.data.ExceededContractsResponse?.ErrorDescriptionAr
            : response.data.ExceededContractsResponse?.ErrorDescriptionEn
        );
      } else {
        toast.error(
          isArabic()
            ? response.data.OperationResponse.ErrorDescriptionAr
            : response.data.OperationResponse.ErrorDescriptionEn
        );
      }
    });
  };
  const reject = () => {};
  const confirm = (systemServiceId: any) => {
    confirmDialog({
      message: (
        <Trans>
          <div
            dangerouslySetInnerHTML={{
              __html: t("unassignSystemConfirmation"),
            }}
          />
        </Trans>
      ),
      header: t("confirmUnassignHeader"),
      acceptLabel: t("yes"),
      rejectLabel: t("no"),
      defaultFocus: "reject",
      acceptClassName: "p-button-danger",
      accept: () => unassignSystemService(systemServiceId),
      reject,
    });
  };
  const handleChange = (event: any): void => {
    let name = "",
      value;
    if (event?.originalEvent?.target?.inputMode === "numeric") {
      value = event.originalEvent.target.value;
      name = event.originalEvent.target.name;
    } else {
      value = event.target.value;
      name = event.target.name;
    }
    let system = selectedSystems.find(
      (se: { systemServiceId: any }) =>
        se.systemServiceId === name.split("_")[1]
    );
    const index = selectedSystems.findIndex(
      (se: { systemServiceId: any }) =>
        se.systemServiceId === name.split("_")[1]
    );
    const editedSystems = [...selectedSystems];
    if (system) {
      system = { ...system, [name.split("_")[0]]: value };
      editedSystems[index] = system;
      setSelectedSystems(editedSystems);
    }
    validate(editedSystems);
  };

  function validate(systems: any) {
    var isValid = true;
    var index;
    var editedSystems = [];
    for (index in systems) {
      {
        var system = systems[index];
        if (systems[index].make) {
          system = { ...system, ["isMakeNull"]: false };
        } else {
          system = { ...system, ["isMakeNull"]: true };
          isValid = false;
        }

        if (systems[index].model) {
          system = { ...system, ["isModelNull"]: false };
        } else {
          system = { ...system, ["isModelNull"]: true };
          isValid = false;
        }

        if (systems[index].quantity) {
          system = { ...system, ["isQuantityNull"]: false };
        } else {
          system = { ...system, ["isQuantityNull"]: true };
          isValid = false;
        }

        editedSystems.push(system);
      }
      setSelectedSystems(editedSystems);
    }
    return isValid;
  }

  const nextClicked = () => {
    setIsNextButtonClicked(true);

    // if (selectedSystems && selectedSystems.length < 1) {
    //   toast.error(t("systemsSelectionValidation"));
    //   return false;
    // }
    //validate on required
    const isValid = validate(selectedSystems);
    const oldIds = contractDetails.contractSystemServicesInfo.map(
      (system: any) => system.systemServiceId
    );
    const newSelectedIds = selectedSystems.map(
      (system: any) => system.systemServiceId
    );
    const isSystemsChanged = !_.isEqual(oldIds, newSelectedIds);
    contractDetails = {
      ...contractDetails,
      contractSystemServicesInfo: selectedSystems,
    };

    dispatch(setContractInfo(contractDetails));
    return { isValid, isSystemsChanged };
  };
  const backClicked = () => {
    console.log("back Clicked");
    console.log("contractDetails");
    contractDetails = {
      ...contractDetails,
      contractSystemServicesInfo: selectedSystems,
    };
    dispatch(setContractInfo(contractDetails));
  };

  return (
    <>
      {!isSystemsPopupOpened && <AssignBuildingTitle />}
      <HeaderBreadCrumb></HeaderBreadCrumb>
      <div className="registration-form building-details-form">
        <ConfirmDialog />
        <h1 className="text-center m-auto">{t("systemsInfo")}</h1>
        <div className="building-details-form__content">
          <div className="building-details-form__content-wrapper d-grid gap-4">
            <div className="all-systems">
              {systems?.map(
                (system: { icon: any; englishName: any; arabicName: any }) => (
                  <div
                    className="d-flex justify-content-between align-items-center gap-2 system-box"
                    key={getFieldFieldValue(system)}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <img
                        style={{ height: 36 }}
                        src={`data:image/png;base64,${system.icon.fileBase64}`}
                        alt="Base64"
                      />
                      <span> {getFieldFieldValue(system)}</span>
                    </div>
                    <Button
                      text
                      className="system-btn"
                      onClick={() => addSystem(system)}
                    >
                      +
                    </Button>
                  </div>
                )
              )}
            </div>
            <div className="selected-systems">
              {selectedSystems.length ? (
                <div className="selected-systems__row font-size-medium">
                  {t("addedSystems")}:
                </div>
              ) : (
                <></>
              )}
              {selectedSystems.length ? (
                selectedSystems.map(
                  (
                    selected: {
                      systemService: any;
                      systemServiceArabic: any;
                      quantity: any;
                      make: any;
                      model: any;
                      systemServiceId: any;
                      isMakeNull: boolean;
                      isQuantityNull: boolean;
                      isModelNull: boolean;
                    },
                    index: number
                  ) => (
                    <div
                      className="selected-systems__row"
                      key={selected.systemServiceId as any}
                    >
                      <div className="d-flex justify-content-between align-items-center gap-2 system-box">
                        <h4>
                          {getTextValueById(
                            selected?.systemServiceId,
                            systems as unknown as [],
                            "systemServiceId"
                          )}
                        </h4>
                        <Button
                          text
                          className="system-btn"
                          onClick={() => removeSystem(selected)}
                        >
                          -
                        </Button>
                      </div>
                      <div className="form-group-row d-flex flex-nowrap gap-2 system-quantity">
                        <div className="form-group d-flex flex-column">
                          <label
                            htmlFor={"quantity_" + selected?.systemServiceId}
                            className="required"
                          >
                            {t("quantity")}:
                          </label>
                          <CustomInputNumber
                            id={"quantity_" + selected?.systemServiceId}
                            name={"quantity_" + selected?.systemServiceId}
                            onChange={handleChange}
                            value={selected?.quantity}
                            className={`${
                              isNextButtonClicked && selected.isQuantityNull
                                ? "invalid-input"
                                : ""
                            }`}
                          />
                          {isNextButtonClicked && selected.isQuantityNull && (
                            <p className="error">{t("required")}</p>
                          )}
                        </div>
                        <div className="form-group d-flex flex-column">
                          <label
                            htmlFor={"make_" + selected?.systemServiceId}
                            className="required"
                          >
                            {t("make")}:
                          </label>
                          <input
                            id={"make_" + selected?.systemServiceId}
                            name={"make_" + selected?.systemServiceId}
                            onChange={handleChange}
                            value={selected?.make}
                            className={`${
                              isNextButtonClicked && selected.isMakeNull
                                ? "invalid-input"
                                : ""
                            }`}
                          ></input>
                          {isNextButtonClicked && selected.isMakeNull && (
                            <p className="error">{t("required")}</p>
                          )}
                        </div>
                        <div className="form-group d-flex flex-column">
                          <label
                            htmlFor={"model_" + selected?.systemServiceId}
                            className="required"
                          >
                            {t("model")}:
                          </label>
                          <input
                            name={"model_" + selected?.systemServiceId}
                            id={"model_" + selected?.systemServiceId}
                            onChange={handleChange}
                            value={selected?.model}
                            className={`${
                              isNextButtonClicked && selected.isModelNull
                                ? "invalid-input"
                                : ""
                            }`}
                          ></input>
                          {isNextButtonClicked && selected.isModelNull && (
                            <p className="error">{t("required")}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  )
                )
              ) : (
                <div className="selected-systems__row empty-systems text-center">
                  <Inventory2Icon fontSize="large" className="mb-2" />
                  <h4> {t("emptySystems")}</h4>
                  <p>{t("emptySystemDescription")}</p>
                </div>
              )}
            </div>
          </div>
          <div></div>
        </div>
        <FooterActions
          current={"systems"}
          previous={"contract"}
          nextPage={"consent"}
          onNextClick={nextClicked}
          onBackClick={backClicked}
          selectedSystems={selectedSystems}
        ></FooterActions>
      </div>
    </>
  );
};

export default Systems;
